import { events } from './events';
import alert from './alert';

export default {
  install(Vue, options) {
    if (this.installed) return;
    this.installed = true;

    Vue.component('capustaAlert', alert);

    Vue.prototype.$alert = function(params) {
      events.$emit('show', {
        type: params.type,
        title: params.title,
        description: params.description,
      });
    };
  },
};
